import styled from "styled-components";
import { Flex } from "@chakra-ui/react";

export const Wrapper = styled(Flex)`
  .favicon {
    display: none;
  }
  .favicon_small {
    display: block;
  }
  .brand_full {
    display: block;
  }
  .brand_full_lg {
    display: none;
  }
  .navigation_text_sm {
    display: none;
  }
  .navigation_text_lg {
    display: block;
  }
  .navigation_menu_wrapper_sm {
    justify-content: center;
  }
  .navigation_menu_wrapper_lg {
    justify-content: space-between;
  }
  .icon_sm {
    display: none;
  }
  .icon_lg {
    display: block;
  }
  .nav_container {
    &:hover {
      & .collapse {
        display: block;
      }
      & .expand {
        width: 18vw;
        z-index: 10;
        cursor: pointer;
        transition-property: width;
        transition-duration: 0.3s;
        transition-timing-function: linear;
        &:hover {
          .favicon_small {
            display: none;
          }
          .brand_full_lg {
            display: block;
          }
          .navigation_text_sm {
            display: block;
          }
          .navigation_menu_wrapper_sm {
            justify-content: space-between;
          }
          .icon_sm {
            display: block;
          }
        }
      }
      ~ .content {
        width: 82%;
        margin-left: 18%;
      }
    }
  }
  .collapse {
    position: absolute;
    right: -3px;
    z-index: 90;
    top: 25px;
    cursor: pointer;
    background-color: transparent;
    color: black;
    padding: 0.4em;
    border-top-left-radius: 25px;
    border-bottom-left-radius: 25px;
    display: none;
    background-color: #251169;
    color: white;
    &:hover {
      border: 1px solid #000;
      background: none;
      color: #251169;
    }
  }
`;
